<script setup lang="tsx">
import { PermAuditRead } from '@/models/enums-generated'
import store from '@/stores/slider'
import IconButton from '@/components/shared/IconButton.vue'
import { computed } from 'vue'
import methodEditor from '@/stores/method-editor'
import jiraCbStore from '@/stores/jira-checkboxes'
import { hasPermission } from '@/services/utils'

const editor = methodEditor()
const jiraStore = jiraCbStore()
const slider = store()

function click() {
	slider.openAudit()
}
async function addToAudit() {
	await editor.addSelectedToAudit()
	editor.massEdit.selected.splice(0)
}

async function removeFromAudit() {
	await editor.removeSelectedFromAudit()
	editor.massEdit.selected.splice(0)
}

const isAuditMode = computed(() => {
	return !editor.isEditMode && !jiraStore.isJiraMode
})
const canView = computed(() => hasPermission(PermAuditRead))

const isSelected = computed(() => {
	return editor.massEdit.selected.length
})
</script>

<template>
	<IconButton
		v-if="isAuditMode && canView"
		id="add-to-audit-btn"
		class="bi bi-clipboard-plus position-relative"
		:title="$t('audit.addToAudit')"
		:count="editor.massEdit.selected.length"
		:disabled="!isSelected"
		@click="addToAudit"
	/>

	<IconButton
		v-if="isAuditMode && canView"
		id="remove-from-audit-btn"
		class="bi bi-clipboard-minus position-relative"
		:title="$t('audit.removeFromAudit')"
		:count="editor.massEdit.selected.length"
		:disabled="!isSelected"
		@click="removeFromAudit"
	/>
	<IconButton v-if="isAuditMode && canView" id="audit-btn" class="bi bi-clipboard-check" :title="$t('audit.label')" @click="click" />
</template>
